import {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";

export default function useStateWithRef<T>(
  defaultValue: T
): [r: MutableRefObject<T>, v: T, u: Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(defaultValue);
  const valueRef = useRef<T>(defaultValue);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  return [valueRef, value, setValue];
}
